import setFullbanner from './home/1_fullbanner';
import setIconsVertical from './home/icons_vertical';
import setBannersLinha from './home/home_banner_linha';
import setCarousel from '../components/carousel';
import setBlogPosts from './home/2_2_categories';
import CategoryTabs from '../pages/home/3_category_tabs'
//addImports

import setTopBar from '../components/topBar';
import handleConditionalLazy from '../components/conditionalLazy';

const Home = {
  init: function () {
    setTopBar();
    handleConditionalLazy();

    setFullbanner()
		setIconsVertical();
		setBannersLinha();
		setCarousel();
		setBlogPosts();
    CategoryTabs.init();
		//calls
  },
};

window.addEventListener('DOMContentLoaded', () => {
  Home.init();
});
